export const CLICKME_SIGNIFICANT_DEBT_THRESHOLD = -100;
